import { render, staticRenderFns } from "./ImageInformation.vue?vue&type=template&id=a245277c&"
import script from "./ImageInformation.vue?vue&type=script&lang=js&"
export * from "./ImageInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports